import plugins from '../plugins'
export default function (param) {
    plugins.call('openService', {
        target: '/compat/service/analyse',
        data: param
    },()=>{})
}